module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-sam-0357e200887c38850cc02e63c4fd24ac.png";